import { cloneDialog } from "@/utilities/template_helpers";

Turbo.config.forms.confirm = (message, element) => {
  const { dialog, dialogElement } =
    cloneDialog(JSON.parse(message), element.getAttribute("method"));

  return new Promise((resolve) => {
    document.body.appendChild(dialog);

    dialogElement.addEventListener(
      "dialog:confirm",
      () => {
        resolve(true);
      },
      { once: true }
    )

    dialogElement.addEventListener(
      "dialog:unconfirm",
      () => {
        resolve(false);
      },
      { once: true }
    )
  });
};
